export default __webpack_public_path__ + "static/media/arrow-down.85ad3178.svg";